module.exports = __webpack_public_path__ + "static/media/employeeManager.aea04f11.png";